import ValidationRule from './ValidationRule';

class NonEmptyValidationRule extends ValidationRule {
  validate(val) {
    return !!val;
  }
}

export default NonEmptyValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/NonEmptyValidationRule.js